export class PngAsset {
  private static readonly dir = '/asset/png';

  public static readonly furoshikiLogo = `${PngAsset.dir}/furoshiki-logo.png`;
  public static readonly logoBlack = `${PngAsset.dir}/logo-black.png`;
  public static readonly logoWhite = `${PngAsset.dir}/logo-white.png`;
}
